<template>
  <header
    class="mobile-config-header d-flex justify-content-between p-3 shadow-sm mb-1 align-items-center"
  >
    <a href="/">
      <img :src="logoSrc" class="logo height-36" alt="Sachsenkabel pulse / zur Startseite" title="Sachsenkabel pulse / zur Startseite">
    </a>
    <div class="d-flex align-items-center">
      <a
        v-if="$store.state.loggedIn && !isFromDigiKey"
        href="/cart"
        class="height-36 d-flex align-items-center width-48 position-relative"
      >
        <i class="fas fa-shopping-cart fa-2x text-saka-green cart"></i>
        <span
          v-if="showCartItemCountBadge"
          class="cart-items-badge rounded-circle bg-saka-orange text-light text-xs px-2 py-1"
        >{{ cartItemsCount }}</span>
      </a>
      <a
        v-if="isFromDigiKey"
        href="https://www.digikey.de/"
        class="height-36 d-flex align-items-center width-48 ms-3"
        title="Zurück zu DigiKey"
      >
        <i class="fas fa-times fa-2x text-saka-red"></i>
      </a>
    </div>
  </header>
</template>

<script>
export default {
  name: 'MobileHeader',
  props: {
    cartItemsCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      defaultLogo: `${this.$pathPrefix}/assets/sachsenkabel_logo_FINAL_cropped.svg`,
      digikeyLogo: `${this.$pathPrefix}/assets/digikey-logo-250px_new.png`
    };
  },
  computed: {
    showCartItemCountBadge() {
      return this.cartItemsCount > 0;
    },
    logoSrc() {
      return this.isFromDigiKey ? this.digikeyLogo : this.defaultLogo;
    },
    isFromDigiKey() {
      return localStorage.getItem('userSource') === 'digikey';
    }
  },
  mounted() {
    const showDigikey = localStorage.getItem('userSource');
    const hasRefreshed = localStorage.getItem('hasRefreshed');

    if (!showDigikey) {
      const urlParams = new URLSearchParams(window.location.search);
      const source = urlParams.get('source');
      if (source === 'digikey' && !hasRefreshed) {
        localStorage.setItem('userSource', 'digikey');
        localStorage.setItem('hasRefreshed', 'true');
        window.location.reload();
      }
    }

    if (hasRefreshed) {
      localStorage.removeItem('hasRefreshed');
    }
  }
}
</script>

<style scoped>
.height-36 {
  height: 36px;
}

.width-48 {
  width: 48px;
}

.cart-items-badge {
  position: absolute;
  top: -0.5em;
  left: 1.5em;
}

.ms-3 {
  margin-left: 1rem;
}
</style>